/** One allocator for all local cast producers, including prediction correlation.
 * Kept monotonic across reconnects; a fresh server session has its own namespace.
 */
let nextSequence = 1;
export function nextClientCastSequence(): number {
  if (!Number.isSafeInteger(nextSequence)) throw new Error('Client cast sequence exhausted; reload required');
  return nextSequence++;
}
